import { useCallback } from 'react'

import PlainButton from 'app/common/ui-next/plain-button'
import ControlsBar from 'app/common/ui-next/controls-bar'
import PlainModal, {
  PlainModalHeader,
  PlainModalContent,
  PlainModalFooter,
} from 'app/common/ui-next/plain-modal'

import styles from './SellPointSettingsModal.module.scss'
import { Loading } from 'app/common/templates-next/page-template'
import PlainCheckbox from 'app/common/ui-next/plain-checkbox'
import { useSalePointCategoriesState } from './useSalePointCategoriesState'
import { ProductQuantityLimit } from './ProductQuantityLimit'

type Props = {
  header: string
  headPhrase: string
  orgId: number
  salePointId: number
  onClose?: () => void
}

export const SellPointSettingsModal = ({
  header,
  headPhrase,
  orgId,
  salePointId,
  onClose,
}: Props) => {
  const { categoryList, selected, selectedComplexes, limitSingleItemInPurchase, onSave, loading, pending } =
    useSalePointCategoriesState({ orgId, salePointId })

  const handleSubmit = useCallback(
    async (form: HTMLFormElement) => {
      const isValid = await onSave(form)
      if (isValid) {
        onClose?.()
      }
    },
    [onSave, onClose],
  )

  return (
    <PlainModal className={styles.root} onSubmit={handleSubmit} show>
      <PlainModalHeader onCrossClick={onClose}>{header}</PlainModalHeader>
      <PlainModalContent>
        {loading ? <Loading /> : <ProductQuantityLimit initialLimit={limitSingleItemInPurchase} disabled={pending} />}
      </PlainModalContent>
      {!loading && (
        <PlainModalContent className={styles.headPhrase}>{headPhrase}</PlainModalContent>
      )}
      <PlainModalContent className={styles.form}>
        {!loading && (
          <div>
            <PlainCheckbox
              name="useComplexes"
              value={'useComplexes'}
              id={'useComplexes'}
              key={'useComplexes'}
              label={'Комплекты'}
              defaultChecked={selectedComplexes}
            />
            {categoryList.map((category) => (
              <PlainCheckbox
                name="categories"
                value={category.id}
                id={category.id}
                key={category.id}
                label={category.title}
                defaultChecked={selected?.includes(category.id)}
              />
            ))}
          </div>
        )}
      </PlainModalContent>
      <PlainModalFooter>
        {(handleModalDisplayed) => (
          <ControlsBar right>
            <PlainButton onClick={onClose || handleModalDisplayed} outline>
              {'Отмена'}
            </PlainButton>
            <PlainButton disabled={loading || pending} type="submit">
              {pending ? 'Сохранение...' : 'Сохранить'}
            </PlainButton>
          </ControlsBar>
        )}
      </PlainModalFooter>
    </PlainModal>
  )
}
